(function () {
  'use strict';

  var STORAGE_KEY = 'getcho-dp-state';
  var mountQueued = false;

  function cleanZip(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 5);
  }

  function readSavedState() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      return {};
    }
  }

  function saveZip(zip) {
    try {
      var state = readSavedState();
      state.zip = zip;
      state.tab = 'shipping';
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      /* Preference persistence is optional. */
    }
  }

  function refreshCheckerAccordionHeight(node) {
    var accordion = node && node.closest ? node.closest('custom-accordion') : null;
    if (!accordion || accordion.getAttribute('data-open') !== 'true') return;

    window.requestAnimationFrame(function () {
      if (typeof accordion.setAccordionTextHeight === 'function') {
        accordion.setAccordionTextHeight(true);
      }
    });
  }

  function setResult(result, state, message) {
    result.hidden = false;
    result.dataset.state = state;
    result.textContent = message;
    refreshCheckerAccordionHeight(result);
  }

  function initChecker(checker) {
    if (!checker || checker.dataset.szReady === 'true') return;
    checker.dataset.szReady = 'true';

    var form = checker.querySelector('[data-sz-delivery-form]');
    var input = checker.querySelector('[data-sz-delivery-input]');
    var result = checker.querySelector('[data-sz-delivery-result]');
    var prefixes = (checker.dataset.servicePrefixes || '').split(',').map(function (item) {
      return item.trim();
    }).filter(Boolean);

    if (!form || !input || !result) return;

    var saved = cleanZip(readSavedState().zip);
    if (saved) input.value = saved;

    input.addEventListener('input', function () {
      input.value = cleanZip(input.value);
      result.hidden = true;
      result.textContent = '';
      refreshCheckerAccordionHeight(result);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var zip = cleanZip(input.value);
      input.value = zip;

      if (zip.length !== 5) {
        setResult(result, 'error', 'Enter a valid five-digit ZIP code.');
        input.focus();
        return;
      }

      saveZip(zip);
      var inReviewArea = prefixes.indexOf(zip.slice(0, 3)) !== -1;

      if (inReviewArea) {
        setResult(
          result,
          'review',
          'This ZIP may be eligible for same-day delivery during service hours. Add to cart to check current availability. The live delivery fee is confirmed at checkout.'
        );
      } else {
        setResult(
          result,
          'error',
          'Same-day delivery is currently limited to select OC & LA ZIP codes. Standard California shipping is still available.'
        );
      }
    });
  }

  function syncNoZoneState(picker) {
    var fallback = picker.querySelector('#getcho-dp-fedex');
    if (!fallback) return;
    var noZone = window.getComputedStyle(fallback).display !== 'none';
    picker.classList.toggle('sz-getcho-no-zone', noZone);

    var shippingForm = picker.querySelector('#getcho-dp-shipping-form');
    var zipInput = picker.querySelector('#getcho-dp-zip');
    var message = picker.querySelector('[data-sz-getcho-zone-status]');

    if (!message && shippingForm) {
      message = document.createElement('div');
      message.className = 'getcho-dp-id-notice sz-getcho-zone-status';
      message.setAttribute('data-sz-getcho-zone-status', '');
      message.hidden = true;
      shippingForm.insertAdjacentElement('beforebegin', message);
    }

    if (!message) return;

    var zip = zipInput ? zipInput.value.replace(/\D/g, '') : '';
    var eligible = !noZone && !!shippingForm && zip.length === 5 && window.getComputedStyle(shippingForm).display !== 'none';
    var text = eligible
      ? 'Same-day delivery is available for this ZIP code. Enter your full delivery address at checkout to view the live delivery rate.'
      : '';

    if (message.textContent !== text) message.textContent = text;
    if (message.hidden === eligible) message.hidden = !eligible;
  }

  function wireAgeGate(summary, checkoutButton) {
    if (!summary || !checkoutButton || checkoutButton.dataset.szAgeGate === 'true') return;
    checkoutButton.dataset.szAgeGate = 'true';

    var checkbox = summary.querySelector('input[name="attributes[21+ Signature Required]"]');
    var error = summary.querySelector('[data-sz-age-error]');
    if (!checkbox) return;

    checkbox.addEventListener('change', function () {
      if (checkbox.checked && error) {
        error.hidden = true;
        error.textContent = '';
      }
    });

    checkoutButton.addEventListener('click', function (event) {
      if (checkbox.checked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (error) {
        error.hidden = false;
        error.textContent = 'Confirm that the recipient is 21+ before continuing to checkout.';
      }
      checkbox.focus();
    }, true);
  }

  function mountCartPicker() {
    var host = document.getElementById('sakezen-delivery-options-host');
    var actionHost = document.getElementById('sakezen-getcho-cta-host');
    var picker = document.getElementById('getcho-dp-picker');
    if (!host || !actionHost || !picker) return;

    var summary = host.closest('.cart-summary-card');
    if (!summary) return;

    if (picker.parentNode !== host) host.appendChild(picker);
    var loading = host.querySelector('.sz-delivery-options__loading');
    if (loading) loading.remove();

    picker.querySelectorAll('*').forEach(function (node) {
      var label = (node.textContent || '').trim();
      if (node.children.length === 0 && /^v\d+(?:\.\d+)*$/i.test(label)) {
        node.hidden = true;
        node.setAttribute('aria-hidden', 'true');
      }
    });

    var shippingButton = picker.querySelector('#getcho-dp-checkout-shipping');
    var actions = shippingButton ? shippingButton.closest('.getcho-dp-actions') : null;
    if (actions && actions.parentNode !== actionHost) actionHost.appendChild(actions);

    summary.classList.add('sz-getcho-ready');
    syncNoZoneState(picker);
    wireAgeGate(summary, shippingButton);
  }

  function mountAll() {
    document.querySelectorAll('[data-sz-delivery-checker]').forEach(initChecker);
    mountCartPicker();
  }

  function scheduleMount() {
    if (mountQueued) return;
    mountQueued = true;
    window.requestAnimationFrame(function () {
      mountQueued = false;
      mountAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', scheduleMount);
  document.addEventListener('cart:refresh', scheduleMount);
  document.addEventListener('cart:updated', scheduleMount);
  document.addEventListener('cart:change', scheduleMount);

  if (window.MutationObserver) {
    new MutationObserver(scheduleMount).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'hidden']
    });
  }
})();
